<app-responsive-modal [closeButton]="true" #countryPopupModal *ngIf="initialCountry">
  <div class="mb-6">
    {{ 'countryPopup.retainCountry' | cxTranslate: { country: getCountryName(initialCountry) } }}
  </div>
  <button class="btn btn-full btn-primary mb-9" [disabled]="pendingSubmit" (click)="closeModal()">
    {{ 'countryPopup.buttonRetain' | cxTranslate }}
  </button>

  <div class="my-6">{{ 'countryPopup.changeCountry' | cxTranslate }}</div>
  <form [formGroup]="localeForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <ng-container *ngIf="countries$ | async as countries">
        <app-form-select>
          <app-form-label>{{ 'countryPopup.countryLabel' | cxTranslate }}</app-form-label>
          <ng-select
            formControlName="country"
            [searchable]="false"
            [clearable]="false"
            [items]="countries"
            bindLabel="country"
          >
            <ng-template ng-label-tmp let-item="item">
              <ng-container
                [ngTemplateOutlet]="countryOption"
                [ngTemplateOutletContext]="{ item }"
              ></ng-container>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <ng-container
                [ngTemplateOutlet]="countryOption"
                [ngTemplateOutletContext]="{ item }"
              ></ng-container>
            </ng-template>
          </ng-select>
        </app-form-select>
      </ng-container>
    </div>

    <div class="mb-3 hidden" *ngIf="languages$">
      <ng-container *ngIf="languages$ | async as languages">
        <app-form-select>
          <app-form-label>{{ 'countryPopup.languageLabel' | cxTranslate }}</app-form-label>
          <ng-select
            formControlName="language"
            [searchable]="false"
            [clearable]="false"
            [items]="languages"
            bindLabel="name"
          ></ng-select>
        </app-form-select>
      </ng-container>
    </div>

    <div class="mt-6 d-flex justify-content-center">
      <button type="submit" class="btn btn-full btn-primary" [disabled]="pendingSubmit">
        {{ 'countryPopup.buttonChange' | cxTranslate }}
      </button>
    </div>
  </form>

  <div class="mt-8 mb-9 fs-14">
    <p class="mb-0">{{ 'countryPopup.infoText' | cxTranslate }}</p>
  </div>
</app-responsive-modal>

<ng-template #countryOption let-item="item">
  <app-svg
    class="d-inline-block"
    [iconName]="item.code"
    assetPath="/assets/icons/countries"
    height="1rem"
    width="1.5rem"
  ></app-svg>
  <span class="ml-2">{{ item.name }}</span>
</ng-template>
